import React, { useState } from "react";
import { FullscreenOutlined } from "@ant-design/icons";
import { Button, Empty, Modal, Tooltip } from "antd";
import { DistributionGraph } from "./DistributionGraph";
import { cmToInches } from "../../../../utils/cmToInchesConversion";

const Graphs = ({ forecastData, specData, currentSite }) => {
  const isImperial = currentSite?.metadata?.siteConfig?.display_units === "imperial";

  const BIN_START = 0;
  const BIN_END = isImperial ? Math.ceil(cmToInches(25)) * 2 : 25;
  const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);
  const hasGraphData = Boolean(forecastData?.forecast_harvest_data?.length);
  const fullscreenInset = "clamp(8px, 2.2vw, 24px)";
  const fullscreenWrapperPadding = "clamp(4px, 1.1vw, 12px)";

  return (
    <div className="w-full">
      <div className="graph-section relative w-full rounded-md px-5 py-2.5 xl:px-4 lg:px-3 md:px-2 sm:px-1.5 shadow-md transition-shadow duration-300 hover:shadow-2xl">
        {hasGraphData && (
          <Tooltip title="Open fullscreen">
            <Button
              type="text"
              aria-label="Open distribution graph in fullscreen"
              icon={<FullscreenOutlined />}
              onClick={() => setIsFullscreenOpen(true)}
              className="!absolute right-2 top-2 z-20 !text-primaryBlue"
            />
          </Tooltip>
        )}
        {hasGraphData ? (
          <DistributionGraph
            BIN_START={BIN_START}
            BIN_END={BIN_END}
            forecastData={forecastData.forecast_harvest_data}
            specData={specData}
            isImperial={isImperial}
          />
        ) : (
          <Empty description="Graph data is not available to show" />
        )}
      </div>

      <Modal
        open={isFullscreenOpen}
        onCancel={() => setIsFullscreenOpen(false)}
        footer={null}
        title={null}
        width={`calc(100% - ${fullscreenInset})`}
        centered={true}
        destroyOnHidden={true}
        styles={{
          wrapper: {
            overflow: "hidden",
            padding: fullscreenWrapperPadding,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          body: {
            padding: 0,
            height: `calc(100dvh - ${fullscreenInset})`,
            overflow: "hidden",
          },
          content: {
            padding: 0,
            height: `calc(100dvh - ${fullscreenInset})`,
            overflow: "hidden",
          },
        }}
        style={{
          paddingBottom: 0,
          maxWidth: "none",
          margin: "0 auto",
        }}
        className="!max-w-none"
      >
        <div className="h-full min-h-0 overflow-hidden p-3 lg:p-1.5 md:p-1 sm:p-0.5">
          {hasGraphData && (
            <DistributionGraph
              BIN_START={BIN_START}
              BIN_END={BIN_END}
              forecastData={forecastData.forecast_harvest_data}
              specData={specData}
              isImperial={isImperial}
              isFullscreen={true}
            />
          )}
        </div>
      </Modal>
    </div>
  );
};

export { Graphs };
